import Backbone from 'backbone';

import App from '../App';

let app: App;

export default function (routers: Array<typeof Backbone.Router>): void {
  for (const router of routers) {
    // eslint-disable-next-line no-new, new-cap
    new router();
  }
  app = new App();
  app.initialize();
  app.runWithBackbone();
}

export function hotReload(routers: Array<typeof Backbone.Router>): void {
  for (const router of routers) {
    // eslint-disable-next-line no-new, new-cap
    new router();
  }
  app.hotReload();
}
